// extracted by mini-css-extract-plugin
export var container = "BetOddsWithDeductions-module--container--d978f";
export var content = "BetOddsWithDeductions-module--content--b26b8";
export var deductions = "BetOddsWithDeductions-module--deductions--49d82";
export var info = "BetOddsWithDeductions-module--info--3c44f";